// removed by extract-text-webpack-plugin
module.exports = {"container":"SamlLogin__container__2d1Ek"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/SamlLogin/SamlLogin.css
// module id = 3270
// module chunks = 0